<script lang="ts">
    import {Component, mixins, Provide, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {TourStoreMixin} from '@/mixins/TourStoreMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class TourBookingPageLayout extends mixins(TourStoreMixin) {
        @Provide() isPackageBooking = true

        async prepareBook() {
            const data = {
                offerKey: this.offer.offerKey,
                entries: [],
            }
            this.offer.entries.forEach(({entryName, selectedOfferKey}) => {
                if (selectedOfferKey) data.entries.push({entryName, offerKey: selectedOfferKey})
            })
            await this.$api.updatePackageTourPrice.put(data)
            await callComponentMethod(this, BookingPageBase, 'prepareBook')
        }

        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageBase,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            const carEntry = this.offer.entries.find(entry => entry.type === 'CAR' && entry.selectedOfferKey)
            if (carEntry) {
                prepareBookRequest.entryParams.push({
                    entryName: carEntry.entryName,
                    entryType: carEntry.type,
                    pickUpPoint: carsRentStore.pickUpLocation.locationCode,
                    dropOffPoint: carsRentStore.dropOffLocation.locationCode,
                })
            }
            return prepareBookRequest
        }

        productConfirmationPageQuery(orderId) {
            return {
                orderId,
                packageTourId: this.$route.query.packageTourId,
            }
        }

        productBookingPageQuery(paymentStatus) {
            return {
                paymentStatus,
                offerKey: this.$route.query.offerKey,
                packageTourId: this.$route.query.packageTourId,
            }
        }

        clearCommentsAfterBooking() {}

        get productSearchPageName() {
            return 'tour'
        }

        get productConfirmationPageName() {
            return 'tourConfirmation'
        }

        get productName() {
            return 'tour'
        }

        get productBookingPageName() {
            return 'tourBooking'
        }

        get corporatePolicyType() {
            return null
        }
    }

    export default {...toNative(TourBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
